import { useQuery } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';

import { type ApiResponse } from '@src/types/api';

import { fetchData } from '@framework/api/apiCalls';
import { api } from '@framework/constants/endpoints';
import { ServerStateKeys } from '@framework/constants/serverStateKeys';

import { type Room } from '@type/rooms';

type UseRoomParams = {
    id?: string;
    organisationId?: string;
    staleTime?: number;
    noRedirect?: boolean;
    enabled?: boolean;
};

const fetchRoom = async (params: UseRoomParams) => {
    if (!params.id) {
        return undefined;
    }

    const response: AxiosResponse<ApiResponse<Room>> = await fetchData(api.room(params.id), {
        params: {
            organisationId: params.organisationId
        },
        noRedirect: params?.noRedirect
    });
    return response.data.results;
};

const useRoom = (params: UseRoomParams) => {
    return useQuery({
        queryKey: [ServerStateKeys.Room, params.id],
        queryFn: () => fetchRoom(params),
        enabled: !!params.id,
        ...params
    });
};

export default useRoom;
